import { Amplify } from 'aws-amplify'

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_AWS_COGNITO_POOL_ID,
      userPoolClientId: import.meta.env.VITE_AWS_COGNITO_WEB_CLIENT_ID,
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_AWS_COGNITO_OAUTH_DOMAIN,
          scopes: ['email', 'profile', 'openid'],
          redirectSignIn: [import.meta.env.VITE_AWS_COGNITO_REDIRECT_SIGNIN],
          redirectSignOut: [import.meta.env.VITE_AWS_COGNITO_REDIRECT_SIGNOUT],
          responseType: 'code'
        }
      }
    }
  }
})
